import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from "../icon/icon";
export var ID = 'icon-status-icon';
export var STATUS_COLORS = {
  RED: 'red',
  GREEN: 'green',
  BLUE: 'blue',
  ORANGE: 'orange',
  YELLOW: 'yellow'
};
export var SVGStatusIcon = function SVGStatusIcon() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 12 12"
  }, React.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "6",
    fillRule: "evenodd"
  }));
};

var StatusIcon = function StatusIcon(_ref) {
  var status = _ref.status,
      className = _ref.className,
      onClick = _ref.onClick;
  return React.createElement(Icon, {
    id: ID,
    className: cx('Icons-status', "Icons-status-".concat(status), className),
    onClick: onClick,
    svg: SVGStatusIcon
  });
};

StatusIcon.propTypes = {
  status: PropTypes.oneOf([STATUS_COLORS.RED, STATUS_COLORS.GREEN, STATUS_COLORS.BLUE, STATUS_COLORS.ORANGE, STATUS_COLORS.YELLOW]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default StatusIcon;